import {disposeSearchData} from "./utils";
import {rulesNotEmpty} from "./formRules";

export let headerCellStyle = { background: '#F3F3F3', color: '#999999' };
export let pagingMixins = {
  data() {
    return {
      loading: false,
      /* 筛选 */
      searchData: {
        searchType: '',
        searchValue: '',
      },
      /* 表格 */
      headerCellStyle,
      tableData: [],
      tableDataSelectValue: [],
      /* 分页参数 */
      pageSizes: [10,20,30,40,50],
      pageSize: 10,
      totalListNum: 10,
      currentPage: 1,
      /* 编辑弹窗 */
      visibleEditForm: false,
      editFormData: {},
      /* 表单校验 */
      formRules: {
        no: [{trigger: 'blur', required: false}],
        require: [rulesNotEmpty()],
      },
    }
  },
  methods: {
    /**
     * 拼接搜索参数
     */
    jointSearchData() {
      let data = {
        pageNo: this.currentPage,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      data = Object.assign(data, this.searchData,...arguments);
      disposeSearchData(data);
      return data;
    },
    /**
     * 搜索
     */
    search() {
      this.handleCurrentChange();
    },
    /**
     * 获取 列表
     */
    getList() {
      let data = this.jointSearchData();
      // this.loading = true;
      // return this.axios.get('/erp/service?src=jiuyuTransfer&action=notSchedulingOrderList', data)
      //   .then(res => {
      //     this.loading = false;
      //     if(!res.data.isSuccess){
      //       this.tableData = [];
      //       this.totalListNum = 10;
      //       return this.$message.info(res.data.error||"服务器繁忙");
      //     }
      //     this.tableData = res.data.data.dataList;
      //     this.totalListNum = res.data.data.totalCount;
      //     return Promise.resolve(res);
      //   })
      //   .catch((res) => {
      //     this.loading = false;
      //     this.tableData = [];
      //     this.totalListNum = 10;
      //   });
    },
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.currentPage = val;
      this.getList();
    },
    /**
     * 其他
     */
    /*选择变化*/
    selectionChangeValue(value) {
      this.tableDataSelectValue = value;
    },
    /**
     * 弹窗
     */
    showEditForm() {
      this.visibleEditForm = true;
    },
    hideEditForm() {
      this.visibleEditForm = false;
    },
  }

};



// WEBPACK FOOTER //
// ./src/assets/js/pagingMixins.js